<template>
  <div v-if="Object.entries(compTable).length" class="container">
    <div class="card-group">

      <app-display-comp
        v-for="[compName, movies] in Object.entries(compTable)"
		:compName="compName"
		:movies="movies"
        :key="compName"/>

    </div><!-- .card-group -->
  </div><!-- .container -->
  <div v-else>
    <p class="text-center"> Loading ⏳ </p>
  </div>

</template>

<script>
import AppDisplayComp from './AppDisplayComp.vue';

export default {
	components: {
		'app-display-comp': AppDisplayComp
	},
	data() {
		/*global wpData:true*/
		/*eslint no-undef: "error"*/

		return {
			searchTerm: '',
			compTable: {}
		};
	},
	mounted() {
		this.emitter.on('filteredPosts', data => {
			this.compTable = {}
			this.sortMoviesByCompetition(data);
		});
		this.emitter.on('searchTermChanged', data => {
			this.searchTerm = data;
		});
		this.emitter.emit('getFilteredPosts')
	},
	methods: {
		sortMoviesByCompetition(movies) {
			movies.forEach(movie => {
				if (!movie.competition) return
				movie.competition.forEach(competition => {
					if (this.compTable[competition.name]) this.compTable[competition.name].push(movie)
					else this.compTable[competition.name] = [movie]
				}) 
			});
		}
	}
};
</script>

<style scoped>
.card-group {
	gap: 20px;
	justify-content: space-between;
}

.container {
	margin-inline: 0;
}
</style>
